/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
import Upload from '../../component/Inc/Upload';

const PRMaterials = () => {
  return (
    <main className="com_container p_pr_materials">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_9">홍보물 소개</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">내용 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="15%" />
                <col width="10%" />
                <col width="40%" />
                <col width="10%" />
                <col width="15%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>제작 방법</th>
                  <th>내용</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회수</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td>2022 겨울방학 특강 브로셔</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td>2022 겨울방학 특강 브로셔</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td>2022 겨울방학 특강 브로셔</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td>2022 겨울방학 특강 브로셔</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>18</td>
                </tr>
                <tr className="selected">
                  <td>13</td>
                  <td className="td_date">2022,08,25</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td>2022 겨울방학 특강 브로셔</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>18</td>
                </tr>

                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{12 - idx}</td>
                      <td className="td_date">2022,08,25</td>
                      <td>
                        <button className="btn_link">인쇄 교재</button>
                      </td>
                      <td>2022 겨울방학 특강 브로셔</td>
                      <td>
                        <button className="btn_link blue">다운로드</button>
                      </td>
                      <td>김길동103</td>
                      <td>18</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>

            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">인쇄홍보물</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">디지털 홍보물</label>
                </div>
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" defaultValue={`2022년 겨울방학 틍강 브로셔 입니다.`} />
              </div>
              <div className="input_box">
                <textarea className="textarea" placeholder="내용 입력(에디터)"></textarea>
              </div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center">
              <div className="com_btn orange s wl">등록</div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default PRMaterials;
